module.exports = __webpack_public_path__ + "media/images/icon_mutes-5e7612d5c63fedb3fc59558284304cfc.png";